module.exports = __webpack_public_path__ + "static/media/login-mobile.fb466593.svg";